import { useQuery } from '@tanstack/react-query';
import { scopeParams, shipmentsApi } from '../api/endpoints';
import { queryKeys } from '../api/queryKeys';
import { useStoreContext } from '../context/StoreContext';

/**
 * Count of накладные still «Ожидает цен» — surfaced as a badge on the nav and
 * a banner on the dashboard so the owner notices unpriced shipments without
 * opening the section. Follows the global store context (SPEC §5): with a
 * store selected the badge counts only that store's backlog. Shares the
 * `['shipments', …]` prefix, so any shipment mutation's
 * `invalidateQueries(['shipments'])` refreshes it too.
 */
export function usePendingShipmentsCount(enabled = true): number {
  const { storeId, storeIds } = useStoreContext();
  const scope = { storeId, storeIds };
  const query = useQuery({
    queryKey: queryKeys.shipmentsPendingCount(scope),
    // Never fired without a business in scope (platform admin before picking one).
    enabled,
    queryFn: () =>
      shipmentsApi.list({
        status: 'PENDING_PRICING',
        pageSize: 1,
        ...scopeParams(scope),
      }),
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
  return query.data?.total ?? 0;
}
